import { combineReducers } from 'redux';
import changePrices from './changePrices';
import deleteFilter from './deleteFilter';
import demandForecast from './demandForecast';
import priceComposition from './priceComposition';
import priceEventHistory from './priceEventHistory';
import ruleComposition from './ruleComposition';
import ruleCompositionOffer from './ruleCompositionOffer';
import saveFilters from './saveFilters';

const root = combineReducers({
  priceComposition,
  ruleComposition,
  priceEventHistory,
  ruleCompositionOffer,
  demandForecast,
  saveFilters,
  deleteFilter,
  changePrices,
});

export default root;
